module.exports = (s) => {
  return [
    {
      name: 'ID',
      value: 'id',
    },
    {
      name: '定向包名称',
      value: 'name',
    },
    {
      name: '操作',
      width: 250,
      align: 'center',
      format: (row) => {
        const h = s.$createElement;
        const view_ele = h('el-button',
          {
            props: {
              type: 'success',
              size: 'mini',
              loading: s.add_btn_loading || row.detail_btn_loading,
            },
            on: {
              click: (e) => {
                e.stopPropagation();
                s.onDetail(row);
              },
            },
          },
          '查看',
        );
        const edit_ele = h('el-button',
          {
            props: {
              type: 'primary',
              size: 'mini',
              loading: s.add_btn_loading || row.edit_btn_loading,
            },
            on: {
              click: (e) => {
                e.stopPropagation();
                s.onEditTargeting(row);
              },
            },
          },
          '编辑',
        );
        const delete_ele = h('el-button',
          {
            props: {
              type: 'danger',
              size: 'mini',
              loading: s.add_btn_loading || row.delete_btn_loading,
            },
            on: {
              click: (e) => {
                e.stopPropagation();
                s.onDeleteTargeting(row);
              },
            },
          },
          '删除',
        );
        return h('div', null, [view_ele, edit_ele, delete_ele]);
      },
    },
  ];
};
